module.exports = __webpack_public_path__ + "media/images/topics/topics-ft-arrows-20d446dcfe71418b4feaf576efc10ff8.png";